import type { MapDef } from '../world/map';
import type { RGB } from './noise';
import { colorAtXinyi, PLACEHOLDER_XINYI } from './groundXinyi';
import { colorAtXimen, PLACEHOLDER_XIMEN } from './groundXimen';
import { colorAtCks, PLACEHOLDER_CKS } from './groundCks';
import { colorAtHlcity, PLACEHOLDER_HLCITY } from './groundHlcity';
import { colorAtTaroko, PLACEHOLDER_TAROKO } from './groundTaroko';
import { colorAtKaohsiung, PLACEHOLDER_KAOHSIUNG } from './groundKaohsiung';
import { colorAtTainan, PLACEHOLDER_TAINAN } from './groundTainan';
import { colorAtBarcelona, PLACEHOLDER_BARCELONA } from './groundBarcelona';

/** Phase E ground materials: each district package owns a few tile chars (see tiles.ts). */
export function colorAt3(map: MapDef, x: number, y: number, mat: string): RGB | null {
  return colorAtXinyi(map, x, y, mat) ?? colorAtXimen(map, x, y, mat) ?? colorAtCks(map, x, y, mat) ?? colorAtHlcity(map, x, y, mat) ?? colorAtTaroko(map, x, y, mat) ?? colorAtKaohsiung(map, x, y, mat) ?? colorAtTainan(map, x, y, mat) ?? colorAtBarcelona(map, x, y, mat);
}

export const PLACEHOLDER3: Record<string, string> = { ...PLACEHOLDER_XINYI, ...PLACEHOLDER_XIMEN, ...PLACEHOLDER_CKS, ...PLACEHOLDER_HLCITY, ...PLACEHOLDER_TAROKO, ...PLACEHOLDER_KAOHSIUNG, ...PLACEHOLDER_TAINAN, ...PLACEHOLDER_BARCELONA };
